import { css } from '@/styled-system/css';

export const skeletonImage = css({
  width: '100%',
  background: 'hpxGrey100',
  height: '100%',
});
